import {
  ATTENTIVE_EMAIL_SUBMIT_EVENT_KEY,
  ATTENTIVE_POPUP_VIEW_EVENT,
} from '@src/quince-site-common/src/utils/addAttentiveSDK/addAttentiveSdk.constants'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { CUSTOM_EVENTS } from '../constants'
import validateEmail from '../validateEmail'

const handleDlChange = (data: any) => {
  const eventData = (data?.detail || [])[0]

  if (eventData?.creative_id) {
    if (eventData.event === ATTENTIVE_POPUP_VIEW_EVENT) {
      trackEvent(TELEMETRY_EVENT_NAMES.FORM_OPEN, {
        action: 'attentive_popup_opened',
        context: {
          creative_id: eventData.creative_id,
        },
      })
    }
    if (eventData.event === ATTENTIVE_EMAIL_SUBMIT_EVENT_KEY) {
      const submittedEmail = eventData.email
      trackEvent(TELEMETRY_EVENT_NAMES.BUTTON_CLICK, {
        action: 'attentive_email_submitted',
        context: {
          creativeId: eventData.creative_id,
          gender: eventData.attentive_gender,
          // ULU-349: the email the user typed into the popup is consented first-party data.
          // Carry it in `context` so it reaches DE/Iterable as customer identity. In UK
          // (countryCompliant) the tentative email is never persisted to a cookie, so this
          // event payload is the ONLY delivery path — without it, the IA event fires but with
          // no email/customer_id and Iterable can't resolve the customer. The UK logged-out PII
          // strip already exempts this event (entity_id allowlist in InternalAnalytics), so the
          // typed email survives. US/CA unchanged.
          ...(validateEmail(submittedEmail) && { email: submittedEmail }),
        },
      })
    }
  }
}

export function attentiveSdkDlListener() {
  document.addEventListener(CUSTOM_EVENTS.DATA_LAYER_CHANGE, handleDlChange)
}

export function removeSdkDlListener() {
  document.removeEventListener(CUSTOM_EVENTS.DATA_LAYER_CHANGE, handleDlChange)
}
